import React, { useEffect, useState } from 'react';
import './zones.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import fileDownload from 'js-file-download';
import {
  getBoundsFromPoints,
  getColorByType,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useFilterForm,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getZoneData } from '../reducer';
import Loader from '../../../components/base/Loader/Loader';
import {
  deleteZone, exportZones, importZones, loadZoneByIdClear, loadZoneList,
} from '../actions';
import { ZONES_MODULE } from '../../../configs/moduleNames';
import YMap from '../../../components/base/Map/YMap';
import { getPolygon } from '../../../components/base/Map/mapUtils';
import ZoneList from './ZoneList';
import ZoneForm from './ZoneForm';
import { showGlobalConfirm } from '../../System/actions';
import { errorNotification, successNotification, warningNotification } from '../../Notifications/notificationDecorator';

export default function ZonesPage() {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [selected, setSelected] = useState(false);
  const [polygon, setPolygon] = useState(null);
  const [zonePolygons, setZonePolygons] = useState([]);
  const [mapInstance, setMapInstance] = useState(null);
  const { updatePeriod } = useSelector(getSystemData);
  const store = useStore();
  const {
    zoneListMeta,
    zoneList,
    loadingZoneList,
    loadingCurrentZone,
    loadingCreateZone,
    loadingEditZoneById,
    loadingDeleteZone,
    loadingExportZones,
    loadingImportZones,
  } = useSelector(getZoneData);

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[ZONES_MODULE].zoneListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
    };
    const p1 = dispatch(loadZoneList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const { getValues, control } = useFilterForm({}, loadData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    if (selected && !zoneList.find(item => item.id === selected)) {
      setSelected(null);
      setPolygon(null);
    }
    if (mapInstance) {
      setZonePolygons(zoneList.map(z => getPolygonFromZone(z)).filter(Boolean));
    }
  }, [zoneList, mapInstance, selected]);

  const handleClose = () => {
    clearCurrentState();
    setShowForm(false);
    setPolygon(null);
    setSelected(null);
  };

  const handleCreate = () => {
    if (!mapInstance) {
      warningNotification('Карта еще не загружена', 'Попробуйте чуть позже');
      return;
    }
    clearCurrentState();
    setShowForm(true);
    setSelected(null);
    setPolygon(getPolygonFromZone({}));
  };

  const handleSelect = (item, isEdit = false) => event => {
    if (selected === item.id && !isEdit) {
      setSelected(null);
      setPolygon(null);
      return;
    }
    let p = null;
    if (selected !== item.id) {
      setSelected(item.id);
      p = getPolygonFromZone(item);
      setPolygon(p);
    }

    if (mapInstance && item?.area?.coordinates?.length > 0) {
      const b = getBoundsFromPoints(item.area.coordinates);
      if (b) {
        mapInstance.setBounds(b);
      }
    }
  };

  const handleEdit = item => event => {
    if (!mapInstance) {
      warningNotification('Карта еще не загружена', 'Попробуйте чуть позже');
      return;
    }
    handleSelect(item, true)();
    setShowForm(true);
    event.stopPropagation();
    event.preventDefault();
  };

  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление зоны "${item.name || 'Без имени'}"`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteZone(item.id)).then(() => {
        if (selected === item.id) {
          setSelected(null);
          setPolygon(null);
        }
        loadData();
        successNotification('Удаление зоны', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление зоны', getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleImport = files => {
    if (!files) {
      return;
    }
    const data = new FormData();
    for (let i = 0, len = files.length; i < len; i++) {
      const file = files[i];
      data.append('file', file);
    }
    dispatch(importZones(data))
      .then(() => {
        successNotification('Импорт зон', 'Процесс импорта прошел успешно');
        loadData();
      })
      .catch(response => errorNotification('Импорт зон', getResponseError(response)));
    handleClose();
  };

  const handleExport = (format, selectedColumns) => {
    dispatch(exportZones())
      .then(data => {
        if (data) { fileDownload(data, data.filename); }
      })
      .catch(response => errorNotification('Экспорт зон', getResponseError(response)));
    // handleClose();
  };

  const clearCurrentState = () => {
    dispatch(loadZoneByIdClear()).catch(responseLogWithNotification);
  };

  const getPolygonFromZone = zone => {
    const {
      area, name, type, id = '',
    } = zone;
    const p = {
      coordinates: area?.coordinates || [],
      property: {
        id,
        name,
        color: getColorByType(type),
      },
    };
    return getPolygon(p);
  };
  const selectedElement = zoneList.find(item => item.id === selected);
  return (
    <div className="page application-page">
      <Loader loading={loadingZoneList || loadingCurrentZone || loadingDeleteZone || loadingCreateZone || loadingEditZoneById || loadingExportZones || loadingImportZones} />
      <div className="page-content-wrapper">
        <div className="zone-columns">
          {!showForm ? (
            <ZoneList
              handleCreate={handleCreate}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              handleSelect={handleSelect}
              handleImport={handleImport}
              handleExport={handleExport}
              loadData={loadData}
              selected={selected}
              zoneListMeta={zoneListMeta}
              zoneList={zoneList}
              control={control}
            />
          ) : false}
          {showForm
            ? (
              <ZoneForm
                handleClose={handleClose}
                loadData={loadData}
                zone={selectedElement}
                polygon={polygon}
                mapInstance={mapInstance}
              />
            )
            : false}
          <div className="map-columns card">
            <YMap
              classNames="zone-map"
              polygons={polygon ? [polygon] : zonePolygons}
              setMapInstance={i => setMapInstance(i)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
